import * as React from 'react';
import PropTypes from 'prop-types';

import {
    Button,
    createStyles,
    makeStyles,
    Typography,
} from '@material-ui/core';

export const styles = theme => createStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
    },
    button: {
        fontSize: theme.typography.h4.fontSize,
        background: theme.palette.common.white,
        width: 60,
        height: 60,
        borderRadius: '50%',
    },
    display: {
        margin: theme.spacing(2),
        fontSize: theme.typography.h4.fontSize,
    },
});

const useStyles = makeStyles(theme => styles(theme), { name: 'Counter' });

const Counter = ({ onChange, value, ...rest }) => {
    const classes = useStyles();
    const onClick = increase => () => {
        onChange({ target: { value: value + increase } });
    };

    return (
        <div
            className={classes.root}
            {...rest}
        >
            <Button onClick={onClick(-1)} className={classes.button}>-</Button>
            <Typography className={classes.display}>
                {value}
            </Typography>
            <Button onClick={onClick(1)} className={classes.button}>+</Button>
        </div>
    );
};

Counter.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.number,
};

Counter.defaultProps = {
    value: 0,
};

export default Counter;
